var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSensorCharts = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.05,
    height: 12.7,
    viewBox: "0 0 18.05 12.7",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.025 -2.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4,2.6l-.8.8a7.786,7.786,0,0,1,0,11.1l.8.8A8.993,8.993,0,0,0,15.4,2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.4,3.4l-.8-.8a8.993,8.993,0,0,0,0,12.7h0l.8-.8a7.97,7.97,0,0,1,0-11.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4,4.7l-.8.8a4.951,4.951,0,0,1,0,7.1h0l.8.8A6.347,6.347,0,0,0,13.4,4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.7,4.7a6.156,6.156,0,0,0,0,8.7l.8-.8a4.951,4.951,0,0,1,0-7.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,6.2A2.734,2.734,0,0,0,6.2,9,2.8,2.8,0,0,0,9,11.8,2.862,2.862,0,0,0,11.8,9,2.734,2.734,0,0,0,9,6.2Zm1.2,4a1.634,1.634,0,0,1-2.4,0,1.634,1.634,0,0,1,0-2.4,1.634,1.634,0,0,1,2.4,0,1.633,1.633,0,0,1,0,2.4Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSensorCharts);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sensor-charts.00978318ee1b32b8d9637e470e9a6f05.svg";